// src/context/ChatSourceContext.jsx
import { createContext, useContext, useEffect, useMemo, useState } from "react";

const COLLECTIONS = {
    mayorista: "activeUsersMayorista",
    consumidor: "activeUsersConsumidorFinal",
};

const ChatSourceContext = createContext(null);

export function ChatSourceProvider({ children }) {
    const [source, setSource] = useState(
        () => localStorage.getItem("chatSource") || "mayorista"
    );

    useEffect(() => {
        localStorage.setItem("chatSource", source);
    }, [source]);

    const currentCollection = COLLECTIONS[source];

    const value = useMemo(
        () => ({ source, setSource, currentCollection, collections: COLLECTIONS }),
        [source]
    );

    return (
        <ChatSourceContext.Provider value={value}>
            {children}
        </ChatSourceContext.Provider>
    );
}

export function useChatSource() {
    const ctx = useContext(ChatSourceContext);
    if (!ctx) {
        throw new Error("useChatSource debe usarse dentro de <ChatSourceProvider>");
    }
    return ctx;
}
